var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "awaitingTickets" } },
    [
      _c("a-table", {
        staticClass: "custom-table2",
        attrs: {
          columns: _vm.columns(),
          dataSource: _vm.waitingChatGetter,
          locale: {
            emptyText: _vm.$t("message.noVisitorFound"),
          },
          pagination: false,
          rowKey: "_id",
          size: "small",
        },
        on: { change: _vm.toggleSortOrder },
        scopedSlots: _vm._u([
          {
            key: "email",
            fn: function (_, item) {
              return _c("div", {}, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.getVisitorValue(item, "email")) +
                    "\n        "
                ),
              ])
            },
          },
          {
            key: "phone",
            fn: function (_, item) {
              return _c("div", {}, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.getVisitorValue(item, "phone")) +
                    "\n        "
                ),
              ])
            },
          },
          {
            key: "name",
            fn: function (_, item) {
              return _c("div", {}, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      !!item.conversation
                        ? item.conversation.fullname || "-"
                        : !!item.osrPayload
                        ? item.osrPayload.fullname
                        : "-"
                    ) +
                    "\n        "
                ),
              ])
            },
          },
          {
            key: "createdDate",
            fn: function (createdDate) {
              return _c("div", {}, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm._f("date")(createdDate)) +
                    "\n        "
                ),
              ])
            },
          },
          {
            key: "assignedUser",
            fn: function (assignedUser, item) {
              return _c(
                "div",
                {},
                [
                  _c(
                    "a-select",
                    {
                      staticClass: "ticket-select",
                      attrs: {
                        "default-value": assignedUser ? assignedUser._id : null,
                      },
                      on: {
                        change: function (value) {
                          return _vm.handleChange(value, item._id)
                        },
                      },
                    },
                    _vm._l(_vm.users.data, function (user) {
                      return _c(
                        "a-select-option",
                        { key: user._id, attrs: { value: user._id } },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(user.name) +
                              "\n                "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            },
          },
          {
            key: "status",
            fn: function (status, item) {
              return _c(
                "div",
                {},
                [
                  _c(
                    "a-select",
                    {
                      staticClass: "ticket-select",
                      attrs: { "default-value": !!status ? status : null },
                      on: {
                        change: function (value) {
                          return _vm.handleChangeStatus(item._id, value)
                        },
                      },
                    },
                    _vm._l(_vm.statuses, function (status) {
                      return _c(
                        "a-select-option",
                        { key: status._id, attrs: { value: status.title } },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(status.title) +
                              "\n                "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            },
          },
          {
            key: "_id",
            fn: function (_id, item) {
              return _c("div", {}, [
                _c(
                  "div",
                  { staticClass: "d-flex w-100 justify-content-start" },
                  [
                    _vm.checkPermission(
                      _vm.PERMISSION_TYPES["offlineSupportRequest.update"].tr
                        .name
                    )
                      ? _c(
                          "a-button",
                          {
                            directives: [
                              {
                                name: "tippy",
                                rawName: "v-tippy",
                                value: {
                                  followCursor: true,
                                  placement: "bottom-end",
                                },
                                expression:
                                  "{ followCursor: true, placement: 'bottom-end' }",
                              },
                            ],
                            staticClass:
                              "actionButton d-flex align-items-center",
                            attrs: { content: _vm.$t("message.sendResponse") },
                            on: {
                              click: function ($event) {
                                return _vm.view(item)
                              },
                            },
                          },
                          [_c("ActionEdit")],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.checkPermission(
                      _vm.PERMISSION_TYPES["offlineSupportRequest.delete"].tr
                        .name
                    )
                      ? _c(
                          "a-button",
                          {
                            directives: [
                              {
                                name: "tippy",
                                rawName: "v-tippy",
                                value: {
                                  followCursor: true,
                                  placement: "bottom-end",
                                },
                                expression:
                                  "{ followCursor: true, placement: 'bottom-end' }",
                              },
                            ],
                            staticClass:
                              "actionButton d-flex align-items-center",
                            attrs: { content: _vm.$t("message.archived") },
                            on: {
                              click: function ($event) {
                                return _vm.archived(item)
                              },
                            },
                          },
                          [
                            _c(
                              "md-icon",
                              { staticStyle: { color: "#3fc5bd" } },
                              [_vm._v("inventory_2")]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ])
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex justify-content-end mt-3",
          staticStyle: { "margin-bottom": "100px" },
        },
        [
          _c("Pagination", {
            attrs: {
              "page-change": _vm.pageChange,
              "page-sizes": _vm.pageSizes,
              total: _vm.waitingTickets.totalPages * _vm.perPage,
              pageSizeLocalStorageKey: "ticket-page-size",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showingTicket
        ? _c("AwaitingTicketDetails", {
            attrs: { ticket: _vm.showingTicket },
            on: {
              close: function ($event) {
                _vm.showingTicket = null
              },
              confirm: _vm.sendResponse,
              sendAsComment: _vm.sendAsComment,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }